import { 
  ADD_TO_CART_REQUEST, 
  REMOVE_FROM_CART_REQUEST, 
  UPDATE_QUANTITY_REQUEST, 
  FETCH_CART_REQUEST,
  CLEAR_CART, 
  CLEAR_CART_REQUEST,
  PLACE_ORDER,
  PLACE_ORDER_NOW_REQUEST,
  PLACE_ORDER_CART_REQUEST,
  FETCH_ORDER_REQUEST,
  FETCH_ORDERS_LIST_REQUEST,
  FETCH_CART_COUNT_REQUEST
} from './actionTypes';

export const fetchCartRequest = () => ({
  type: FETCH_CART_REQUEST
});

export const fetchCartCountRequest = () => ({
  type: FETCH_CART_COUNT_REQUEST
});

export const addToCartRequest = (productId, qty = 1) => ({
  type: ADD_TO_CART_REQUEST,
  payload: { productId, qty }
});

export const removeFromCartRequest = (itemId) => ({
  type: REMOVE_FROM_CART_REQUEST,
  payload: itemId
});

export const updateQuantityRequest = (itemId, qty, productId) => ({
  type: UPDATE_QUANTITY_REQUEST,
  payload: { itemId, qty, productId }
});

export const clearCartRequest = (cartId) => ({
  type: CLEAR_CART_REQUEST,
  payload: cartId
});

export const clearCart = () => ({
  type: CLEAR_CART
});

export const placeOrder = (shippingInfo, items) => {
  const totalAmount = items.reduce((sum, item) => sum + ((item.unitPrice || item.price || 0) * (item.qty || item.quantity || 1)), 0);
  const newOrder = {
    id: `ORD-${Date.now()}`,
    date: new Date().toISOString(),
    items: [...items],
    totalAmount,
    shippingInfo,
    status: 'Processing'
  };

  return {
    type: PLACE_ORDER,
    payload: newOrder
  };
};

export const placeOrderNowRequest = (orderData) => ({
  type: PLACE_ORDER_NOW_REQUEST,
  payload: orderData
});

export const placeOrderCartRequest = (orderData) => ({
  type: PLACE_ORDER_CART_REQUEST,
  payload: orderData
});

export const fetchOrderRequest = (orderId) => ({
  type: FETCH_ORDER_REQUEST,
  payload: orderId
});

export const fetchOrdersListRequest = (params) => ({
  type: FETCH_ORDERS_LIST_REQUEST,
  payload: params
});
